import { createReducer } from '@reduxjs/toolkit'

import { insertItems, removeItem, upsertItem } from 'redux/utils'

import { TFetchStatus } from 'redux/reducers/Dashboards'

import * as actions from '../../actions/Analyses/actions'
import * as authenticationActions from '../../actions/Authentication/actions'
import { TAnalysisResponse } from 'redux/api/Analyses'

export interface AnalysisReducerType {
  analyses: { [id: string]: TAnalysisResponse }
  fetchStatus: TFetchStatus
}

const keepStoredMeta = (
  existing: TAnalysisResponse | undefined,
  payload: TAnalysisResponse
): TAnalysisResponse =>
  existing?.meta ? { ...payload, meta: existing.meta } : payload

const INITIAL_STATE: AnalysisReducerType = {
  analyses: {},
  fetchStatus: 'idle'
}

const analysisReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetchStatus = 'fetching'
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.analyses = insertItems(action.payload)
      state.fetchStatus = 'success'
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetchStatus = 'error'
    })
    .addCase(actions.getOneSuccess, (state, action) => {
      state.analyses = upsertItem(state.analyses, action.payload.data)
    })
    .addCase(actions.updateSuccess, (state, action) => {
      state.analyses = upsertItem(
        state.analyses,
        keepStoredMeta(state.analyses[action.payload.id], action.payload)
      )
    })
    .addCase(actions.updateSelectionSuccess, (state, action) => {
      // A version 1 selection save must take the new url, because that url
      // is what carries the selection into the document.
      state.analyses = upsertItem(
        state.analyses,
        action.payload.version === 1
          ? action.payload
          : keepStoredMeta(state.analyses[action.payload.id], action.payload)
      )
    })
    .addCase(actions.destroySuccess, (state, action) => {
      state.analyses = removeItem(state.analyses, action.payload)
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default analysisReducer
